"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "index",
  props: {
    row: {
      type: Object,
      default: function _default() {}
    }
  },
  filters: {
    sexFilter: function sexFilter(status) {
      var statusMap = {
        0: '未知',
        1: '男',
        2: '女',
        3: '保密'
      };
      return statusMap[status];
    }
  },
  methods: {
    //性别
    getSexImage: function getSexImage(sex) {
      var iconMap = {
        0: 'unknown.png',
        1: 'man.png',
        2: 'woman.png',
        3: 'unknown.png'
      };
      var imageName = iconMap[sex] || 'unknown.png';
      return require("@/assets/imgs/".concat(imageName));
    },
    sexFilter: function sexFilter(status) {
      var statusMap = {
        0: '未知',
        1: '男',
        2: '女',
        3: '保密'
      };
      return statusMap[status];
    }
  }
};